import { useCallback } from 'react';
import {
  DialogOpenChangeDetails,
  useDisclosure,
  UseDisclosureProps,
  UseDisclosureReturn,
} from '@chakra-ui/react';

export type UseOpenCloseReturn = UseDisclosureReturn & {
  onOpenChange: ({ open }: DialogOpenChangeDetails) => void;
};

export const useOpenClose = (props?: UseDisclosureProps) => {
  const { open, onOpen, onClose, onToggle, setOpen } = useDisclosure(props);

  const onOpenChange = useCallback(
    ({ open: isOpen }: DialogOpenChangeDetails) => {
      setOpen(isOpen);
      if (isOpen) {
        props?.onOpen?.();
      } else {
        props?.onClose?.();
      }
    },
    [props?.onClose, props?.onOpen],
  );

  return {
    open,
    onOpen,
    onClose,
    onToggle,
    setOpen,
    onOpenChange,
  };
};
